import React from "react";

export interface IconMembersProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconMembers: React.FC<IconMembersProps> = ({
  width = 23,
  height = 16,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 23 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.9 8C9.12453 8 10.925 6.21071 10.925 4C10.925 1.78929 9.12453 0 6.9 0C4.67547 0 2.875 1.78929 2.875 4C2.875 6.21071 4.67547 8 6.9 8ZM9.66 9.14286H9.36172C8.61422 9.5 7.78406 9.71429 6.9 9.71429C6.01594 9.71429 5.18937 9.5 4.43828 9.14286H4.14C1.85437 9.14286 0 10.9857 0 13.2571V14.2857C0 15.2321 0.772656 16 1.725 16H12.075C13.0273 16 13.8 15.2321 13.8 14.2857V13.2571C13.8 10.9857 11.9456 9.14286 9.66 9.14286ZM17.25 8C19.1547 8 20.7 6.46429 20.7 4.57143C20.7 2.67857 19.1547 1.14286 17.25 1.14286C15.3453 1.14286 13.8 2.67857 13.8 4.57143C13.8 6.46429 15.3453 8 17.25 8ZM18.975 9.14286H18.8384C18.3389 9.31429 17.8106 9.42857 17.25 9.42857C16.6894 9.42857 16.1611 9.31429 15.6616 9.14286H15.525C14.7919 9.14286 14.1162 9.35357 13.5233 9.69286C14.4002 10.6321 14.95 11.8786 14.95 13.2571V14.6286C14.95 14.7071 14.932 14.7821 14.9284 14.8571H21.275C22.2273 14.8571 23 14.0893 23 13.1429C23 10.9321 21.1995 9.14286 18.975 9.14286Z"
      fill={fill}
    />
  </svg>
);
